<div class="LinktoApplication-card">
  <div class="doc-insidecard">
    <div class="category-activity-header">
      <wm-common-text [data]="{ text: 'List of Applications Related to this Type of Inspection' }"></wm-common-text>
    </div>

    <wm-common-text [data]="{ text: 'Click “link icon” to connect an application',
      fontSize: '14px',
      fontWeight: 400
    }" class="Optional-instructional-text"></wm-common-text>

    <div class="search-bar">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" placeholder="Search" (input)="onSearch($event)"/>
      </div>
    </div>


    <wm-common-table 
    *ngIf="columns && filteredData"
    [columns]="columns" 
    tableType="Staff" 
    [data]="filteredData" 
    [serverSidePagination]="true" 
    [totalPages]="totalPages"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    >
    </wm-common-table>
  </div>
</div>

<wm-common-confirmation-modal
  [data]="deleteConfirmModal"
  (onYesClick)="confirmDeleteLinkedApplication()"
  (onNoClick)="closeDeleteLinkedApplicationModal()"
>
</wm-common-confirmation-modal>